import { BillingStatus } from "../types/billings";

export const billingStatusColorMap: Record<string, string> = {
  [BillingStatus.Active]: "var(--green)",
  [BillingStatus.Closed]: "var(--blue)",
  [BillingStatus.New]: "var(--orange)",
};
